"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trans = exports.TransProvider = exports.t = exports.getTransResources = exports.reloadTranslation = exports.langDirection = exports.initialize = void 0;
/**
 * Expose i18n helper functions to clients.
 * We don't want developers to directly import libs.
 *
 * Documentation:
 *  - https://react.i18next.com/
 */
var I18NProvider_1 = __importDefault(require("./components/I18NProvider"));
var I18NTrans_1 = __importDefault(require("./components/I18NTrans"));
var i18nHelper_1 = __importDefault(require("./helpers/i18nHelper"));
exports.initialize = i18nHelper_1.default.init;
exports.langDirection = i18nHelper_1.default.dir;
exports.reloadTranslation = i18nHelper_1.default.reload;
exports.getTransResources = i18nHelper_1.default.getCurrentResources;
exports.t = i18nHelper_1.default.translate;
exports.TransProvider = I18NProvider_1.default;
exports.Trans = I18NTrans_1.default;
